import React from 'react';

// Sargamicons SVG Icon Components for Prebooking Flow
// Based on Figma design specifications

// ArrowBackIcon - Back navigation arrow
export const ArrowBackIcon = ({ color = '#ffffff', size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M14.1667 10H5.83337M5.83337 10L10 14.1667M5.83337 10L10 5.83337"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// PersonIcon - User silhouette (for interpreter count banner)
export const PersonIcon = ({ color = '#ffffff', size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 10C11.8409 10 13.3333 8.50761 13.3333 6.66667C13.3333 4.82572 11.8409 3.33333 10 3.33333C8.15905 3.33333 6.66666 4.82572 6.66666 6.66667C6.66666 8.50761 8.15905 10 10 10Z"
      fill={color}
    />
    <path
      d="M10 11.6667C7.775 11.6667 3.33334 12.7833 3.33334 15V16.6667H16.6667V15C16.6667 12.7833 12.225 11.6667 10 11.6667Z"
      fill={color}
    />
  </svg>
);

// ExpandMoreIcon - Chevron down (dropdown indicator)
export const ExpandMoreIcon = ({ color = '#000000', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 10L12 14L16 10"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// ExpandLessIcon - Chevron up (collapse indicator)
export const ExpandLessIcon = ({ color = '#000000', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 14L12 10L16 14"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// CalendarIcon - Calendar for date inputs
export const CalendarIcon = ({ color, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="2.5" y="4.16667" width="15" height="13.3333" rx="2" stroke={color} strokeWidth="1.5" />
    <path d="M2.5 8.33333H17.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M6.66666 2.5V5.83333" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M13.3333 2.5V5.83333" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// TimeIcon - Clock for time inputs
export const TimeIcon = ({ color, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="7.5" stroke={color} strokeWidth="1.5" />
    <path d="M10 5.83333V10L12.5 12.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// DeleteIcon - Trash can for removing items
export const DeleteIcon = ({ color = '#45446b', size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 5.83333V15.8333C5 16.7538 5.74619 17.5 6.66667 17.5H13.3333C14.2538 17.5 15 16.7538 15 15.8333V5.83333"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 5.83333V4.16667C7.5 3.24619 8.24619 2.5 9.16667 2.5H10.8333C11.7538 2.5 12.5 3.24619 12.5 4.16667V5.83333"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.33334 5.83333H16.6667" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// AddCircleIcon - Plus in circle for adding items
export const AddCircleIcon = ({ color, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10" cy="10" r="7.5" stroke={color} strokeWidth="1.5" />
    <path d="M10 6.66667V13.3333" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M6.66666 10H13.3333" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// DownloadIcon - Arrow down for file upload/browse
export const DownloadIcon = ({ color, size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 2.5V12.5M10 12.5L5.83334 8.33333M10 12.5L14.1667 8.33333"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.33334 17.5H16.6667" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

// CloseIcon - X mark for removing/closing
export const CloseIcon = ({ color = '#45446b', size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4 4L12 12M12 4L4 12"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

// ChevronRightIcon - For step indicator (rotated to point right)
export const ChevronRightIcon = ({ color = '#45446b', size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 8L14 12L10 16"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
